import SVGProps from 'src/components/icons/config/svg-props' //
// Auto-generated file created by svgr-cli source svg-template.cjs
// Run npm run generate-icons to update
// Do not edit
const SvgFunnelIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill="none"
    viewBox="0 0 64 64"
    role="img"
    className="icon"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeWidth={3}
      d="M53.3 10H10.7a.7.7 0 0 0-.7.7v7.605a.7.7 0 0 0 .198.489l16.676 17.122a.7.7 0 0 1 .198.488v16.057a.7.7 0 0 0 1.16.528l9.864-8.596a.7.7 0 0 0 .24-.528v-7.478a.7.7 0 0 1 .178-.467L53.822 18.79a.7.7 0 0 0 .178-.466V10.7a.7.7 0 0 0-.7-.7Z"
    />
  </svg>
)
export default SvgFunnelIcon
